export enum AccountBankTypeEnum {
    CURRENT = 'current',
    SAVINGS = 'savings',
}

export enum PixKeyTypeEnum {
    CPF = 'cpf',
    CNPJ = 'cnpj',
    EMAIL = 'email',
    PHONE = 'telefone',
    RANDOM = 'aleatoria',
}